import InputField from "components/fields/InputField";
import Card from "components/card";
import Loading from "components/loading/Loading";
import { useState } from "react";
import axiosClient from "axios-client.js";
import { useStateContext } from "context/ContextProvider.jsx";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

export default function SignIn() {
    const navigate = useNavigate();
    const [load, setLoad] = useState(false);
    const [message, setMessage] = useState({});
    const [state, setState] = useState({
        email: null,
        password: null,
    });
    const { setUser, setToken } = useStateContext();

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setState((state) => ({ ...state, [name]: value }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setLoad(true);
        setMessage({});
        axiosClient
            .post("/auth/login", state)
            .then(({ data }) => {
                setLoad(false);
                setUser(data.user_data);
                setToken(data.token);

                navigate("/my/homepage", {
                    replace: true,
                });
            })
            .catch((err) => {
                const response = err.response;
                setLoad(false);
                if (response) {
                    setMessage({
                        text: response.data.message,
                        type: "ERROR",
                        errors: response.data.errors
                            ? response.data.errors
                            : {},
                    });
                }
            });
    };

    return (
        <div className="mt-0 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mt-16 lg:mb-10 lg:items-center lg:justify-start">
            {/* Sign in section */}
            {load ? <Loading /> : null}
            <div className="mx-auto mt-0 w-full max-w-full flex-col items-center lg:mt-[10vh] xl:max-w-[544px]">
                <Card extra="p-6 md:p-[32px]">
                    <img
                        src="/img/logo.svg"
                        alt="Proxima"
                        className="mx-auto mb-4 w-64 p-0"
                    />
                    <hr className="-mx-6 mb-6 border-lightPrimary md:-mx-[40px]" />
                    <h4 className="mb-2.5 text-center text-3xl font-bold text-gray-800 dark:text-white">
                        Accedi
                    </h4>
                    <p className="mb-6 ml-1 text-center text-[14.5px] text-gray-800">
                        Inserisci email e password per effettuare l'accesso
                    </p>
                    <form onSubmit={handleSubmit}>
                        {message.hasOwnProperty("text") ? (
                            <div
                                className={
                                    "mb-6 ml-1 text-center text-base " +
                                    (message.type === "SUCCESS"
                                        ? "text-green-500"
                                        : message.type === "ERROR"
                                        ? "text-red-500"
                                        : message.type === "WARNING"
                                        ? "text-amber-500"
                                        : null)
                                }
                            >
                                <p>{message.text}</p>
                            </div>
                        ) : null}
                        {/* Email */}
                        <InputField
                            extra="mb-4"
                            label="Email*"
                            placeholder="email@esempio.com"
                            type="email"
                            name="email"
                            value={state.email || ""}
                            onChange={handleChange}
                            required={true}
                            state={
                                message.hasOwnProperty("errors")
                                    ? message.errors.hasOwnProperty("email")
                                        ? "error"
                                        : null
                                    : null
                            }
                            error={
                                message.hasOwnProperty("errors")
                                    ? message.errors.hasOwnProperty("email")
                                        ? message.errors.email
                                        : null
                                    : null
                            }
                        />

                        {/* Password */}
                        <InputField
                            extra="mb-4"
                            label="Password*"
                            placeholder="Min. 8 characters"
                            type="password"
                            name="password"
                            value={state.password || ""}
                            onChange={handleChange}
                            required={true}
                            state={
                                message.hasOwnProperty("errors")
                                    ? message.errors.hasOwnProperty("password")
                                        ? "error"
                                        : null
                                    : null
                            }
                            error={
                                message.hasOwnProperty("errors")
                                    ? message.errors.hasOwnProperty("password")
                                        ? message.errors.password
                                        : null
                                    : null
                            }
                        />
                        <div className="mb-6 mt-3 flex items-center justify-between px-2">
                            <Link
                                to="/auth/forgot-password"
                                className="text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
                            >
                                Password dimenticata?
                            </Link>
                            <Link
                                to="/auth/request-new-account"
                                className="text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
                            >
                                Non hai ancora un account?
                            </Link>
                        </div>
                        <button
                            type="submit"
                            className="linear mt-2 w-full rounded-[8px] bg-brand-500 py-[12px] text-base font-bold uppercase text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                        >
                            Accedi
                        </button>
                    </form>
                </Card>
            </div>
        </div>
    );
}
